module.exports = __webpack_public_path__ + "img/shape_triangle.31941538.png";